import React from "react";
import { EditorState, Modifier } from "draft-js";

const VARIABLE_REGEX = /%%(\w+)%%/g;

const findVariableEntities = (contentBlock, callback) => {
  const text = contentBlock.getText();
  let matchArr;
  // eslint-disable-next-line no-cond-assign
  while ((matchArr = VARIABLE_REGEX.exec(text)) !== null) {
    callback(matchArr.index, matchArr.index + matchArr[0].length);
  }
};

const getVariableLabel = (variableDefs, varName) => {
  if (!variableDefs) return "%%" + varName + "%%";
  const def = variableDefs.find((d) => d.id === varName);
  return def ? def.label : "%%" + varName + "%%";
};

const createVariableChip = (variableDefs) => {
  const VariableChip = (props) => {
    const decoratedText = props.decoratedText || "";
    const match = /%%(\w+)%%/.exec(decoratedText);
    const variableName = match ? match[1] : "";
    const label = getVariableLabel(variableDefs, variableName);
    return (
      <span
        className="cro-variable-chip"
        contentEditable={false}
        data-variable={variableName}
      >
        {label}
      </span>
    );
  };
  return VariableChip;
};

export const createVariablePlugin = (variableDefs) => {
  const VariableChip = createVariableChip(variableDefs);
  return {
    decorators: [
      {
        strategy: findVariableEntities,
        component: VariableChip,
      },
    ],
  };
};

export const VariablePickerToolbar = ({
  variableDefs,
  getEditorState,
  setEditorState,
}) => {
  const handleChange = (e) => {
    const id = e.target.value;
    if (!id) return;
    const def = (variableDefs || []).find((d) => d.id === id);
    if (!def) return;

    const editorState = getEditorState();
    const contentState = editorState.getCurrentContent();
    const selection = editorState.getSelection();
    const placeholder = "$" + def.id;

    const newContentState = Modifier.replaceText(
      contentState,
      selection,
      placeholder
    );
    const newEditorState = EditorState.push(
      editorState,
      newContentState,
      "insert-characters"
    );
    setEditorState(newEditorState);

    // reset the select so the same variable can be picked again
    e.target.value = "";
  };

  return (
    <select
      className="cro-variable-picker"
      onChange={handleChange}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
      defaultValue=""
    >
      <option value="" disabled>
        Vložit proměnnou…
      </option>
      {(variableDefs || []).map((def) => (
        <option key={def.id} value={def.id}>
          {def.label}
        </option>
      ))}
    </select>
  );
};
